document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.lh-product-form').forEach(function (form) {
    form.addEventListener('submit', async function (event) {
      // Native POST is Shopify's most reliable fallback. We only intercept to
      // show a quick, friendly transition and then use the documented cart API.
      event.preventDefault();
      var id = form.querySelector('[name="id"]');
      var qty = form.querySelector('[name="quantity"]');
      if (!id || !id.value || !qty || !qty.value || Number(qty.value) < 1) {
        form.submit();
        return;
      }
      var button = form.querySelector('button[type="submit"]');
      if (button) { button.disabled = true; button.dataset.originalText = button.textContent; button.textContent = 'ADDING…'; }
      try {
        var body = new URLSearchParams();
        body.append('id', id.value);
        body.append('quantity', String(Math.max(1, parseInt(qty.value, 10) || 1)));
        var response = await fetch((window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST',
          headers: {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8','Accept':'application/json'},
          body: body.toString()
        });
        if (!response.ok) throw new Error('Cart add failed');
        window.location.href = '/cart';
      } catch (err) {
        // If AJAX is unavailable, submit the exact same valid fields natively.
        form.submit();
      }
    });
  });
  document.addEventListener('click', function(e){ if(e.target.closest('.lh-nav a')) document.body.classList.remove('lh-menu-open'); });
});
